module.exports = __webpack_public_path__ + "static/media/fikafy_how_it_works.89fb158b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fikafy_how_it_works.png
// module id = 77
// module chunks = 0